import { defineNuxtPlugin } from '#app'
import { useSubscriptionStore } from '../stores/subscription'

export default defineNuxtPlugin(async (nuxtApp) => {
  // Wait for auth to be ready before initializing subscription data
  nuxtApp.hook('app:mounted', async () => {
    try {
      const subscriptionStore = useSubscriptionStore()
      
      // Initialize subscription data
      await subscriptionStore.fetchSubscriptionData()
      
      // console.log('Subscription store initialized')
    } catch (error) {
      console.error('Failed to initialize subscription store:', error)
    }
  })
}) 